import { ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Actions, ofActionSuccessful } from '@ngxs/store';
import * as FlatActions from '@medsurf/flat-actions'
import * as FlatFacades from '@medsurf/flat-facades';
import * as FlatModels from '@medsurf/flat-models'

@Component({
    selector: 'medsurf-general-modal',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './general-modal.component.html',
    styleUrls: ['./general-modal.component.scss'],
    standalone: false
})
export class GeneralModalComponent {

  /**
   * Members
   */
  public modals = new Map<string, number>();
  public currentModalTitle = '';
  public currentModalContent = '';
  public modalRef: NgbModalRef;

  /**
   * View Children
   */
  @ViewChild('modalElement') modalElement: TemplateRef<any>;

  public constructor(
    public appSharedFacade: FlatFacades.AppSharedFacade,
    public slideViewerFacade: FlatFacades.SlideViewerFacade,
    public modalService: NgbModal,
    public actions$: Actions) {

    this.actions$.pipe(
      ofActionSuccessful(FlatActions.MediaInteractionViewerActions.OpenModal),
      takeUntilDestroyed(),
    ).subscribe(({ targetId, onClose }: FlatActions.MediaInteractionViewerActions.OpenModal) => {
      const event = this.slideViewerFacade.snapshot_eventModalById(targetId);
      if (event) this.openModal(event, true, onClose);
    })


    this.slideViewerFacade.currentTime$.pipe(takeUntilDestroyed()).subscribe((currentTime) => {
      for (const [id, from] of this.modals) {
        if (currentTime < from) {
          this.modals.delete(id);
        }
      }  
    })
      
    this.slideViewerFacade.currentActiveEvents$.pipe(takeUntilDestroyed()).subscribe((events) => {
      events?.forEach(event => {
        if (event.type === 'modal') {
          this.openModal(event);
        }
      })
    })
  }

  public openModal(event: FlatModels.MediaInteractionViewerModels.MediaInteractionModalEvent, force = false, onClose?: FlatActions.MediaInteractionViewerActions.OpenModal['onClose']) {
    if (!this.modals.has(event.id) || force) {
      this.modals.set(event.id, event.from);
      // Wait for modal to open before pausing
      setTimeout(() => {
        this.slideViewerFacade.requestTogglePlay('pause');
      }, 500);
      this.modalRef = this.modalService.open(this.modalElement, {
        size: event.size ?? 'lg',
        scrollable: true,
        centered: true,
      })
      this.currentModalContent = event.content;
      this.currentModalTitle = event.title;

      this.modalRef.result.finally(() => {
        if (onClose?.type) {
          this.slideViewerFacade.requestTogglePlay(onClose.type);

          if (onClose.value !== undefined) {
            this.slideViewerFacade.requestJumpToTime(onClose.value);
          }
        } else {
          this.slideViewerFacade.requestTogglePlay('play');
        }
        this.currentModalContent = '';
        this.currentModalTitle = '';
      })
    }
  }

  public closeModal() {
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }
}
